module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/icon_step01_c98c3358c22249998db180c40d2bbe8a.png";